<template>
  <div class="van-page">
    <the-header title="工作台" />
    <div class="van-container">
      <div class="van-box">
        <div class="van-cell-header">
          <div class="van-cell-title">我的</div>
          <span style="color: #868A93;" v-if="!handling" @click="handling = !handling">
            自定义 <i class="ri-edit-line"></i>
          </span>
          <span v-if="handling" @click="updateMenu()">
            <button class="confirm">保存</button>
          </span>
        </div>
        <van-grid :border="false" :column-num="4">
          <van-grid-item :text="item.label" v-for="(item, index) in useList" :key="index" @click="handleUseList(item.id)">
            <van-image slot="icon" :src="require(`@/assets/images/gz/${item.icon}`)">
              <div class="subtract" v-show="handling">
                <van-icon name="delete" color="#ff0000" size="22px" />
              </div>
            </van-image>
          </van-grid-item>
        </van-grid>
      </div>
      <div class="van-box">
        <div class="van-cell-header">
          <div class="van-cell-title">全部</div>
        </div>
        <van-grid :border="false" :column-num="4">
          <van-grid-item :text="item.label" v-for="(item, index) in allList" :key="index" @click="handleAllList(item.id)"
            v-show="getShow(item.jurisdiction)">
            <van-image slot="icon" :src="require(`@/assets/images/gz/${item.icon}`)">

              <div class="subtract" v-show="handling && !useList.find(i => i.id == item.id)">
                <van-icon name="add" color="#427afa" size="22px" />
              </div>
            </van-image>
          </van-grid-item>
        </van-grid>
      </div>
    </div>

    <gz-footer></gz-footer>
  </div>
</template>

<script>
import { getMenuList, updateMenuList } from '@/api/interface/home.js'
export default {
  components: {
    'the-header': () => import('@/components/TheHeader'),
    'gz-footer': () => import('@/components/GzFooter'),
  },
  data() {
    return {
      useList: [],
      allList: [
        { id: '1', key: 'log', label: '日志', icon: 'i-log.png', path: '/home/log', jurisdiction: 'KY,KZ' },
        { id: '2', key: 'file', label: '材料', icon: 'i-folder.png', path: '/material', jurisdiction: 'KY,KZ' },
        { id: '3', key: 'code', label: '企业码', icon: 'i-code.png', path: '/home/code', jurisdiction: 'KY,KZ' },
        { id: '4', key: 'manager', label: '项目管家', icon: 'i-housekeeper.png', path: '/home/manager', jurisdiction: 'KZ' },
        { id: '5', key: 'phonebook', label: '电话本', icon: 'i-phone.png', path: '/home/phonebook', jurisdiction: 'KY,KZ' },
      ],
      handling: false
    }
  },
  methods: {
    getMenu: function () {
      const instance = new getMenuList({
        userId: this.$store.getters.getUser.userId
      })
      instance
        .then((result) => {
          const data = result.data.data.split(',')
          this.useList = data.map(item => this.allList.find(i => i.id == item))
        })
        .catch((err) => {
          console.log(err);
        });
    },
    updateMenu: function () {
      this.handling = false
      const instance = new updateMenuList({
        userId: this.$store.getters.getUser.userId,
        menuList: this.useList.map(item => item.id).join(',')
      })
      instance
        .then((result) => {
          console.log(result);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleUseList: function (id) {
      if (this.handling) {
        const index = this.useList.findIndex(i => i.id == id)
        this.useList.splice(index, 1)
      } else {
        this.$router.push({
          path: this.allList.find(i => i.id == id).path
        })
      }
    },
    handleAllList: function (id) {
      if (this.handling) {
        if (this.useList.find(i => i.id == id)) return
        this.useList.push(this.allList.find(i => i.id == id))
      } else {
        this.$router.push({
          path: this.allList.find(i => i.id == id).path
        })
      }
    },
  },
  computed: {
    getShow() {
      return function (jurisdiction) {
        return jurisdiction.indexOf(this.$store.state.user.postType) > -1
      }
    }
  },
  mounted() {
    this.getMenu()
  }
}
</script>

<style lang="less" scoped>
.van-page {
  padding-bottom: 56px;
}

.van-container {
  padding: 16px 16px;
}

.van-cell-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding: 12px 16px;
}

.van-cell-title {
  font-size: 16px;
  color: #000;
}

.van-box {
  background: #fff;
  border-radius: 6px;
  margin-bottom: 10px;
}

::v-deep {
  .van-grid-item__icon-wrapper {
    position: relative;

    .van-image {
      height: 44px;
      width: 44px;

      .subtract {
        all: unset;
        position: absolute;
        right: 0;
        top: 0;
        width: 22px;
        height: 22px;
        transform: translate(50%, -50%);
        display: flex;

        ::v-deep {
          .van-icon {}
        }
      }
    }
  }

  .van-grid-item__text {
    font-size: 14px;
    color: #000000;
  }
}

.confirm {
  all: unset;
  background-color: #427afa;
  color: white;
  padding: 4px 8px;
  border-radius: 8px;
}
</style>